import SkipPrefillButton from './SkipPrefillButton';

export default SkipPrefillButton;
